import Page from 'src/apipages/mcp-server/index';

export default Page;
